import { PlainText } from './PlainText'

export const CodeElement = ({ contents }: { contents: { value: string } }) => (
    <code>
        <PlainText contents={contents.value} />
    </code>
)
